import Container from "@/components/ui/Container";
import SectionLabel from "@/components/ui/SectionLabel";
import ContactForm from "@/components/Forms/ContactForm";
import laptop from "@/assets/mcp/laptop.webp";

export default function ContactFormSection() {
  return (
    <section className="relative overflow-hidden rounded-t-[30px] bg-[#001f40] md:rounded-t-[50px]">
      <Container className="pt-[60px] min-[478px]:pt-[100px] xl:pt-[120px]">
        <div className="relative flex flex-col xl:grid xl:grid-cols-2 xl:gap-[60px]">
          <div className="relative z-10 flex flex-col">
            <SectionLabel>Расширяем наблюдаемость</SectionLabel>
            <h2 className="mt-5 text-[32px] font-bold leading-[1.1] text-white min-[478px]:text-[38px] md:text-[40px] xl:text-[60px]">
              Разберём вашу систему с MCP Ключ-АСТРОМ
            </h2>
            <p className="mt-6 max-w-[328px] text-[16px] font-medium leading-[1.4] text-white xl:mt-[169px]">
              Покажем, какие риски есть сейчас и что влияет на стабильность
            </p>
          </div>

          <img
            src={laptop}
            alt=""
            aria-hidden="true"
            className="pointer-events-none z-0 mx-auto mt-8 w-[450px] max-w-full select-none mix-blend-plus-lighter md:absolute md:right-[-16px] md:top-[120px] md:mt-0 md:w-[430px] xl:bottom-auto xl:left-[6%] xl:right-auto xl:top-[88px] xl:w-[39%]"
          />

          <ContactForm
            subject="MCP — Заявка на консультацию"
            source="mcp_page"
            className="relative z-10 -mx-4 -mt-24 min-[478px]:-mt-16 sm:-mx-16 md:mx-0 md:mt-[320px] xl:mt-0"
          />
        </div>
      </Container>
    </section>
  );
}
